import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs/operators';
import { getAgent, getAgentSuccess, getAgentFail } from '@asm/features/asm/store/agent.actions';
import { AsmConnector } from '@asm/features/asm/services/asm.connector';
import { ASM_AGENT_ID_KEY } from '@shared/tools/constants';

@Injectable()
export class AgentEffects {
  constructor(
    private actions: Actions,
    private asmConnector: AsmConnector,
  ) {}

  getAgent$ = createEffect(() => {
    return this.actions.pipe(
      ofType(getAgent),
      mergeMap(() => {
        const agentId = localStorage.getItem(ASM_AGENT_ID_KEY);
        if (!agentId) {
          return [getAgentFail({ errorMessage: 'No agent ID available' })];
        }

        return this.asmConnector.getAgentUser(agentId).pipe(
          map(user => {
            if (user.hasError) {
              return getAgentFail({ errorMessage: user.message || '' });
            }
            return getAgentSuccess({ agent: user });
          }),
        );
      }),
    );
  });
}
